import { useParams } from "react-router";

import { Header, PageContainer } from "@/components";

import { AssignMaterialList } from "./components/assignMaterialList/AssignMaterialList";
import { ExportAssignedMaterialsBtn } from "./components/assignMaterialExport/ExportAssignedMaterialsBtn";
import { AssignMaterialEditor } from "./components/assignMaterialForm/AssignMaterialForm";

export const AssignMaterials = () => {
  const { edition } = useParams();

  return (
    <PageContainer>
      <Header title="Asignación de materiales">
        <ExportAssignedMaterialsBtn />
      </Header>

      <AssignMaterialList />

      {edition && <AssignMaterialEditor />}
    </PageContainer>
  );
};
